import nxModule from 'nxModule';
import templateUrl from './batch-loan-preterminations.template.html';

nxModule.component('batchLoanPreterminations', {
  templateUrl
});